import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getUserInfo, getDepartmentInfo } from '@/service/proRequisition';
export default function useUserInfo() {
  var userInfo = ref({
    u_name: ''
  });
  //获取当前用户的部门详情信息
  var userDeptInfo = ref({});
  var getUserInfoAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getUserInfo();
          case 2:
            data = _context.sent;
            userInfo.value.u_name = data.user_name;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getUserInfoAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  //获取用户的详细部门信息
  var getDepartmentInfoAsync = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getDepartmentInfo({
              id: 0,
              user_name: userInfo.value.u_name
            });
          case 2:
            data = _context2.sent;
            userDeptInfo.value = data.length ? data[0] : {};
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getDepartmentInfoAsync() {
      return _ref2.apply(this, arguments);
    };
  }();
  return [userInfo, getUserInfoAsync, userDeptInfo, getDepartmentInfoAsync];
}